@if (open) {
  <div
    id="mobile-menu"
    class="fixed inset-0 z-40 lg:hidden"
    role="dialog"
    aria-modal="true"
  >
    <button
      type="button"
      class="absolute inset-0 bg-surface-950/70 backdrop-blur-sm"
      [attr.aria-label]="i18n.t().closeMenu"
      (click)="closed.emit()"
    ></button>

    <nav
      class="absolute inset-x-4 top-20 rounded-2xl border border-white/10 bg-surface-900 p-4 shadow-2xl shadow-black/40"
      aria-label="Móvil"
    >
      <ul class="flex flex-col gap-1">
        @for (item of navItems; track item.href) {
          <li>
            <a
              [href]="item.href"
              class="block rounded-xl px-4 py-3 text-base font-medium text-ink-100 transition hover:bg-white/5"
              (click)="onNavigate()"
            >
              {{ i18n.t()[item.labelKey] }}
            </a>
          </li>
        }
      </ul>

      <div class="mt-3 flex items-center justify-between border-t border-white/10 pt-3">
        <div class="flex items-center rounded-xl border border-white/10 text-xs font-semibold">
          <button
            type="button"
            class="rounded-l-xl px-2.5 py-1.5 transition"
            [class.bg-brand-500/20]="i18n.language() === 'es'"
            [class.text-brand-300]="i18n.language() === 'es'"
            [class.text-ink-500]="i18n.language() !== 'es'"
            (click)="i18n.setLanguage('es')"
          >
            ES
          </button>
          <button
            type="button"
            class="rounded-r-xl px-2.5 py-1.5 transition"
            [class.bg-brand-500/20]="i18n.language() === 'en'"
            [class.text-brand-300]="i18n.language() === 'en'"
            [class.text-ink-500]="i18n.language() !== 'en'"
            (click)="i18n.setLanguage('en')"
          >
            EN
          </button>
        </div>
      </div>

      <div class="mt-3">
        <app-button
          variant="primary"
          [href]="cvPath"
          [download]="cvFilename"
          [fullWidth]="true"
        >
          <span>{{ i18n.t().downloadCv }}</span>
        </app-button>
      </div>
    </nav>
  </div>
}
